module.exports = "/packs/images/svg/move-left~8c99d17e78cccd0cf00e7020b2aaa84e.svg";